"use strict";

var _interopRequireWildcard = require("/root/workspace/merchant_5Yxh/node_modules/@babel/runtime/helpers/interopRequireWildcard.js");
var _interopRequireDefault = require("/root/workspace/merchant_5Yxh/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/root/workspace/merchant_5Yxh/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/merchant_5Yxh/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.function.name");
var _user = require("@/api/user");
var _system = require("@/api/system");
var _auth = require("@/utils/auth");
var _router = _interopRequireWildcard(require("@/router"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var state = {
  token: (0, _auth.getToken)(),
  name: '',
  avatar: '',
  mer_id: localStorage.getItem('mer_id'),
  domain_url: localStorage.getItem('domain_url'),
  introduction: '',
  merchant_admin_id: '',
  roles: [],
  menuList: JSON.parse(localStorage.getItem('MenuList') || '[]'),
  mer_name: '',
  mer_logo: ''
};
var mutations = {
  SET_MENU_LIST: function SET_MENU_LIST(state, menuList) {
    state.menuList = menuList;
  },
  SET_TOKEN: function SET_TOKEN(state, token) {
    state.token = token;
  },
  SET_INTRODUCTION: function SET_INTRODUCTION(state, introduction) {
    state.introduction = introduction;
  },
  SET_MERCHANR_ADMIN_ID: function SET_MERCHANR_ADMIN_ID(state, merchant_admin_id) {
    state.merchant_admin_id = merchant_admin_id;
  },
  SET_NAME: function SET_NAME(state, name) {
    state.name = name;
  },
  SET_AVATAR: function SET_AVATAR(state, avatar) {
    state.avatar = avatar;
  },
  SET_ROLES: function SET_ROLES(state, roles) {
    state.roles = roles;
  },
  SET_MERID: function SET_MERID(state, mer_id) {
    localStorage.setItem('mer_id', mer_id);
    state.mer_id = mer_id;
  },
  SET_DOMAIN: function SET_DOMAIN(state, url) {
    localStorage.setItem('domain_url', url);
    state.domain_url = url;
  },
  SET_MER_NAME: function SET_MER_NAME(state, mer_name) {
    state.mer_name = mer_name;
  },
  SET_MER_LOGO: function SET_MER_LOGO(state, mer_logo) {
    state.mer_logo = mer_logo;
  }
};
var actions = {
  // user login
  login: function login(_ref, userInfo) {
    var commit = _ref.commit;
    // const { username, password } = userInfo
    return new Promise(function (resolve, reject) {
      (0, _user.login)(userInfo).then(function (response) {
        var data = response.data;
        if (data.login_status) {
          commit('SET_TOKEN', data.token);
          _jsCookie.default.set('MerName', data.admin.account);
          (0, _auth.setToken)(data.token);
          commit('SET_DOMAIN', '');
        }
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  stafflogin: function stafflogin(_ref2, userInfo) {
    var commit = _ref2.commit;
    return new Promise(function (resolve, reject) {
      (0, _user.stafflogin)(userInfo).then(function (response) {
        var data = response.data;
        if (data.login_status) {
          commit('SET_TOKEN', data.token);
          _jsCookie.default.set('MerName', data.admin.account);
          (0, _auth.setToken)(data.token);
          commit('SET_DOMAIN', '');
        }
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getMenus: function getMenus(_ref3) {
    var commit = _ref3.commit;
    return new Promise(function (resolve, reject) {
      (0, _user.getMenusApi)().then(function (response) {
        commit('SET_MENU_LIST', response.data);
        localStorage.setItem('MenuList', JSON.stringify(response.data));
        resolve(response);
      }).catch(function (error) {
        // this.$message.error(res.message)
        reject(error);
      });
    });
  },
  // get user info
  getInfo: function getInfo(_ref4) {
    var commit = _ref4.commit,
      state = _ref4.state;
    return new Promise(function (resolve, reject) {
      (0, _user.getInfo)(state.token).then(function (response) {
        var data = response.data;
        if (!data) {
          reject('Verification failed, please Login again.');
        }
        var roles = data.roles,
          name = data.name,
          avatar = data.avatar,
          introduction = data.introduction,
          merchant_admin_id = data.merchant_admin_id;

        // roles must be a non-empty array
        if (!roles || roles.length <= 0) {
          reject('getInfo: roles must be a non-null array!');
        }
        commit('SET_ROLES', roles);
        commit('SET_NAME', name);
        commit('SET_AVATAR', avatar);
        commit('SET_INTRODUCTION', introduction);
        commit('SET_MERCHANR_ADMIN_ID', merchant_admin_id);
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // get user info
  set_uname: function set_uname(_ref5, uname) {
    var commit = _ref5.commit;
    return new Promise(function (resolve, reject) {
      commit('SET_NAME', uname);
      resolve(uname);
    });
  },
  // get user info
  set_merchant_id: function set_merchant_id(_ref6, mer_id) {
    var commit = _ref6.commit;
    return new Promise(function (resolve, reject) {
      commit('SET_MERID', mer_id);
      resolve(mer_id);
    });
  },
  // get user info
  set_merchant_avtar: function set_merchant_avtar(_ref7, avatar) {
    var commit = _ref7.commit;
    return new Promise(function (resolve, reject) {
      commit('SET_AVATAR', avatar);
      resolve(avatar);
    });
  },
  // get user info
  set_merchant_logo: function set_merchant_logo(_ref8, mer_logo) {
    var commit = _ref8.commit;
    return new Promise(function (resolve, reject) {
      commit('SET_MER_LOGO', mer_logo);
      resolve(mer_logo);
    });
  },
  // get user info
  set_merchant_name: function set_merchant_name(_ref9, mer_name) {
    var commit = _ref9.commit;
    return new Promise(function (resolve, reject) {
      commit('SET_MER_NAME', mer_name);
      resolve(mer_name);
    });
  },
  // get user info
  getDomain: function getDomain(_ref10) {
    var commit = _ref10.commit,
      state = _ref10.state;
    return new Promise(function (resolve, reject) {
      // const domain = localStorage.getItem('domain_url');
      // if (domain) {
      //   commit('SET_DOMAIN', domain);
      //   resolve(domain);
      // } else {
      (0, _system.getDomain)(state.token).then(function (response) {
        var data = response.data;
        if (!data) {
          return reject('Verification failed, please Login again.');
        }
        var domain_key = data.domain_key;
        commit('SET_DOMAIN', domain_key);
        resolve(domain_key);
      }).catch(function (error) {
        reject(error);
      });
      // }
    });
  },
  // user logout
  logout: function logout(_ref11) {
    var commit = _ref11.commit,
      state = _ref11.state,
      dispatch = _ref11.dispatch;
    return new Promise(function (resolve, reject) {
      (0, _user.logout)(state.token).then(function () {
        commit('SET_TOKEN', '');
        commit('SET_ROLES', []);
        (0, _auth.removeToken)();
        (0, _router.resetRouter)();
        _jsCookie.default.remove();
        // reset visited views and cached views
        // to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
        dispatch('tagsView/delAllViews', null, {
          root: true
        });
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // remove token
  resetToken: function resetToken(_ref12) {
    var commit = _ref12.commit;
    return new Promise(function (resolve) {
      commit('SET_TOKEN', '');
      commit('SET_ROLES', []);
      (0, _auth.removeToken)();
      resolve();
    });
  },
  // dynamically modify permissions
  changeRoles: function changeRoles(_ref13, role) {
    var commit = _ref13.commit,
      dispatch = _ref13.dispatch;
    return new Promise( /*#__PURE__*/function () {
      var _ref14 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(resolve) {
        var token, _yield$dispatch, roles, accessRoutes;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              token = role + '-token';
              commit('SET_TOKEN', token);
              (0, _auth.setToken)(token);
              _context.next = 5;
              return dispatch('getInfo');
            case 5:
              _yield$dispatch = _context.sent;
              roles = _yield$dispatch.roles;
              (0, _router.resetRouter)();

              // generate accessible routes map based on roles
              _context.next = 10;
              return dispatch('permission/generateRoutes', roles, {
                root: true
              });
            case 10:
              accessRoutes = _context.sent;
              // dynamically add accessible routes
              _router.default.addRoutes(accessRoutes);

              // reset visited views and cached views
              dispatch('tagsView/delAllViews', null, {
                root: true
              });
              resolve();
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref14.apply(this, arguments);
      };
    }());
  }
};
var _default = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};
exports.default = _default;